// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__ncf2t","root__icon":"Checkbox_root__icon__052Yz"};